import React from 'react';

export function Skeleton({ className = '', width, height }) {
  return (
    <div
      className={`animate-pulse rounded-md bg-[#EEF0F6] ${className}`}
      style={{ width, height, backgroundImage: 'linear-gradient(90deg, #EEF0F6, #F4F5FA, #EEF0F6)', backgroundSize: '200% 100%', animation: 'shimmer 1.4s infinite' }}
    />
  );
}

export function SkeletonCard() {
  return (
    <div className="soft-card p-5">
      <div className="flex items-center gap-3 mb-4">
        <Skeleton className="w-10 h-10 rounded-xl" />
        <div className="flex-1">
          <Skeleton className="h-3 w-24 mb-2" />
          <Skeleton className="h-5 w-32" />
        </div>
      </div>
      <Skeleton className="h-3 w-full mb-2" />
      <Skeleton className="h-3 w-3/4" />
    </div>
  );
}

export function SkeletonRow({ cols = 6 }) {
  return (
    <tr className="border-b border-[#F3F4F8]">
      {Array.from({ length: cols }).map((_, i) => (
        <td key={i} className="py-4 px-5"><Skeleton className="h-4 w-24" /></td>
      ))}
    </tr>
  );
}
